define([
    "jquery",
    "underscore",
    "marionette",
    "views/payout/common_view",
    "forms/payout/cup_form"
], function($, _, Marionette, CommonView, CupForm) {
    return CommonView.extend({
        ui: _.extend(CommonView.prototype.ui, {
            'signature': '#signature',
            'signatureName': '#signature_name',
            'bankInfo': '#bank_info',
            'bankName': '#bank_name',
            'bankAccount': '#bank_account',
            'swiftCode': '#swift_code',
            'bankAccountHolder': '#bank_account_holder',
            'bankAddress': '#bank_address'
        }),

        events: _.extend(CommonView.prototype.events, {
            'keyup @ui.signatureName': function(e){
                if(e) e.preventDefault();

                this.updateSignature(this.ui.signatureName, this.ui.signature);
            },
            'change @ui.bankInfo': 'updateBankDetails'
        }),

        initialize: function(){
            this.bindUIElements();
            CommonView.prototype.updateFinancial.call(this);
            this.delegateEvents();
            this.form = new CupForm();
        },

        updateSignature: function($signatureName, $signature){
            // Filter all characters that are not a-z A-Z
            $signatureName.val($signatureName.val().replace(/[^a-zA-Z0-9\s\-\_\,\.]/g, function(str){
                return '';
            }));

            $signature.val($signatureName.val());
        },

        updateBankDetails: function(e){
            if(e) e.preventDefault();

            var bankDetails = window.banks_list[this.ui.bankInfo.val()];

            if(bankDetails){
                this.ui.bankName.val(bankDetails.bank_name);
                this.ui.bankAccount.val(bankDetails.bank_account);
                this.ui.swiftCode.val(bankDetails.swift_code);
                this.ui.bankAccountHolder.val(bankDetails.bank_account_holder);
                this.ui.bankAddress.val(bankDetails.bank_address);
            }else{
                this.ui.bankName.val('');
                this.ui.bankAccount.val('');
                this.ui.swiftCode.val('');
                this.ui.bankAccountHolder.val('');
                this.ui.bankAddress.val('');
            }
        }
    });
});
